import { Typography } from "@mui/material"
import { Address } from "generated/graphql"
import Grid from "@mui/material/Grid"
import React from "react"

export interface AdressContainerProps {
  adr: Address
}

const AdressContainer: React.FC<AdressContainerProps> = (props: AdressContainerProps) => {
  const { adr } = props
  return (
    <Grid
      container
      spacing={1}
      sx={{
        border: "1px solid black",
        borderColor: "grey.500",
        borderRadius: 5,
        padding: 2,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Grid size={12}>
        <Typography variant="h6">Addresse</Typography>
      </Grid>
      <Grid size={12}>
        {adr.company}
      </Grid>
      <Grid size={12}>
        {adr.fullName}
      </Grid>
      <Grid size={12}>
        {adr.street}
      </Grid>
      <Grid size={12}>
        {adr.zipCode} {adr.city}
      </Grid>
      <Grid size={12}>
        {adr.countryCode.toUpperCase()} {adr.country}
      </Grid>
    </Grid>
  );
}

export default AdressContainer
